import { supabase } from './supabase';

/**
 * Get the current season for a club
 * @param {string} clubId - The club ID
 * @returns {Promise<string|null>} - The season ID or null if not found
 */
export const getCurrentSeasonId = async (clubId) => {
  try {
    // First try to get the current season
    const { data: currentSeason, error: seasonError } = await supabase
      .from('seasons')
      .select('id')
      .eq('club_id', clubId)
      .eq('season_status', 'current')
      .maybeSingle();
      
    if (seasonError) {
      console.error('Error fetching current season:', seasonError);
      throw seasonError;
    }
    
    if (currentSeason) {
      console.log('Using current season:', currentSeason.id);
      return currentSeason.id;
    }
    
    // Fallback to most recent season
    console.warn('No current season found, trying most recent');
    const { data: recentSeason, error: recentError } = await supabase
      .from('seasons')
      .select('id')
      .eq('club_id', clubId)
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle();
      
    if (recentError) {
      console.error('Error fetching recent season:', recentError);
      throw new Error('No season found for this club');
    }
    
    if (recentSeason) {
      console.log('Using most recent season:', recentSeason.id);
      return recentSeason.id;
    }
    
    throw new Error('No season found for this club');
  } catch (error) {
    console.error('Error getting season ID:', error);
    throw error;
  }
};
